import { useEffect, useState } from "react";

const subs = new Set<(n: number) => void>();
let timeoutId: ReturnType<typeof setTimeout> | null = null;
let cur = Date.now();

// Self-scheduling tick aligned to wall-clock second boundaries - every
// same-tab iframe fires at the same instant, so clocks flip together.
// clockSync shares the data reference; this shares the repaint phase.
function scheduleTick() {
  timeoutId = setTimeout(() => {
    cur = Date.now();
    subs.forEach((s) => s(cur));
    if (subs.size > 0) {
      scheduleTick();
    } else {
      timeoutId = null;
    }
  }, 1000 - (Date.now() % 1000));
}

export function useNowTick(enabled: boolean = true): number {
  const [now, setNow] = useState(cur);
  useEffect(() => {
    if (!enabled) return;
    subs.add(setNow);
    if (!timeoutId) scheduleTick();
    return () => {
      subs.delete(setNow);
      if (subs.size === 0 && timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    };
  }, [enabled]);
  return now;
}
